module.exports = __webpack_public_path__ + "static/img/zwtp.b4ee2b48.png";